import { formatInteger } from '@/design'
import './list.css'

export interface Paging {
  hasMore: boolean
  loadingMore: boolean
  moreFailed: boolean
  /** Every page is read but some rows are missing: the list changed while it loaded. */
  incomplete: boolean
  onMore: () => void
  onRestart: () => void
}

/** How much of the list is shown, the next page, and what went wrong fetching it. `noun` is the rows' plural: "competitions". */
export function Footer({ shown, total, noun, paging }: { shown: number; total: number; noun: string; paging: Paging }) {
  return (
    <div className="list-footer">
      <p className="list-note">
        Showing {formatInteger(shown)} of {formatInteger(total)} {noun}
      </p>
      {paging.hasMore ? (
        <button type="button" className="ci-button" disabled={paging.loadingMore} onClick={paging.onMore}>
          {paging.loadingMore ? 'Loading more…' : 'Show more'}
        </button>
      ) : null}
      {paging.moreFailed ? (
        <p role="alert" className="list-error">
          More {noun} could not be loaded just now. Try again in a moment.
        </p>
      ) : null}
      {paging.incomplete ? (
        <p role="status" className="list-note">
          The list changed while it loaded, so some {noun} are missing.{' '}
          <button type="button" className="ci-button" data-variant="ghost" onClick={paging.onRestart}>
            Reload the list
          </button>
        </p>
      ) : null}
    </div>
  )
}
